import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 15px;
  .rankmiTable-rowsCount {
    margin-bottom: -8px;
  }
`

export const Options = styled.div`
  text-align: right;
  button {
    font-weight: 700;
    padding: 0 8px;
    color: #4c4c4c !important;
    border-radius: 8px;
    background-color: #f0f0f0 !important;
    margin-left: 8px;
    border: none;
    &:hover {
      color: #4c4c4ca6 !important;
    }
    &:disabled {
      color: #4c4c4c !important;
      opacity: 0.48;
    }
  }
`

export const AddLearningPaths = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    margin-top: 8px;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`
